export default __webpack_public_path__ + "static/media/client3.059c9feb.avif";